<template>
  <div class="p-3 max-w-[360px]">
    <div class="text-h6 font-bold mb-3">Pré-positionner</div>

    <PreposAccordion v-if="positions.length" :list="positions" />
    <div v-else class="max-w-[300px] text-center">Aucun pré-positionnement de signature dans ce document</div>

    <PButton class="mt-3 w-full" @click="addPrepos"> Pré-positionner une signature </PButton>
  </div>
</template>

<script setup lang="ts">
import type { SignPosition } from "@/app/views/PdfViewer/domain/sign-position.domain.ts";
import PreposAccordion from "@/app/views/PdfViewer/tools/PreposAccordion.vue";
import { PButton } from "@pasta/box-v2";
import { useSignEvents } from "../composable/use-sign-events";

type Props = { positions: SignPosition[] };
defineProps<Props>();

const signEvents = useSignEvents();

function addPrepos() {
  signEvents.emit("createPos");
}
</script>
